import React from "react";
import Img from "gatsby-image";
import KeyPerson from "../KeyPerson";

const ThreeFeaturesRow = ({ features, skillOrStrength }) => {
  const featureImage =
    skillOrStrength === "skill" ? "skill_image" : "strength_image";
  const featureName =
    skillOrStrength === "skill" ? "skill_name" : "strength_name";
  const featureDesc =
    skillOrStrength === "skill" ? "skill_desc" : "strength_description";

  return (
    <div className="offers threeStrengths text-center position-relative">
      <div className="row">
        {features.map((feature, i) => (
          <div
            key={i}
            className="col-md-4 col-sm-4 text-center wow fadeIn features-2"
            data-wow-duration="300ms"
          >
            <div className="key-person">
              <div className="key-person-img">
                <img
                  src={feature[featureImage].localFile.childImageSharp.resolutions.src}
                  style={{transition: 'all .3s ease'}}
                />
              </div>
              <div className="key-person-details-wrapper">
                <div className="key-person-details no-border">
                  <h5>{feature[featureName]}</h5>
                  <div className="separator-line bg-black" />
                  <p>{feature[featureDesc]}</p>
                </div>
              </div>
              <div className="fadeOutGrad" />
            </div>
          </div>
          // <KeyPerson
          //   key={i}
          //   img={a[featureImage].localFile.childImageSharp}
          //   name={a[featureName]}
          //   description={a[featureDesc]}
          // />
        ))}
      </div>
    </div>
  );
};

export default ThreeFeaturesRow;



// WEBPACK FOOTER //
// ./src/components/ThreeFeaturesRow/index.js